import { colors, spacing } from '@steelwake/ui';
import type { ReactNode } from 'react';

/** One labelled setting: the label on the left, its control on the right. */
export function Row({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        alignItems: 'center',
        gap: spacing.md,
        padding: '6px 0',
        borderBottom: `1px solid ${colors.border}`,
        fontSize: 14,
      }}
    >
      <span>{label}</span>
      <span style={{ display: 'flex', alignItems: 'center', gap: spacing.sm }}>{children}</span>
    </label>
  );
}

export function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section style={{ marginTop: spacing.lg }}>
      <h2
        style={{
          margin: `0 0 ${spacing.sm}`,
          fontSize: 12,
          letterSpacing: '0.16em',
          textTransform: 'uppercase',
          color: colors.textMuted,
        }}
      >
        {title}
      </h2>
      {children}
    </section>
  );
}
